export default __webpack_public_path__ + "static/media/saunatimeTwitter-600x314.c0be6eb4.jpg";